<template>
  <div class="type-tabs">
    <button
      v-for="type in DOC_TYPES"
      :key="type"
      class="type-tab"
      :class="{ active: type === modelValue }"
      @click="$emit('update:modelValue', type)"
    >
      {{ type }}
    </button>
  </div>
</template>

<script setup>
import { DOC_TYPES } from "../store";

defineProps({
  modelValue: { type: String, default: "判决书" },
});
defineEmits(["update:modelValue"]);
</script>

<style scoped>
.type-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  background: #eef2f7;
  border-radius: 11px;
  width: max-content;
  max-width: 100%;
  overflow: auto;
}
.type-tab {
  height: 34px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #61718a;
  padding: 0 14px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}
.type-tab:hover {
  color: #1768ff;
  background: rgba(23, 104, 255, 0.08);
}
.type-tab.active {
  background: #fff;
  color: #1768ff;
  box-shadow: 0 2px 8px rgba(31, 57, 105, 0.08);
}
</style>
